export const brightcoveUrlParser = (url: string) => {
  const [accountId, playerId, videoId] = url.split("//")[1].split("/");

  console.log({
    accountId,
    playerId,
    videoId,
  });

  return {
    accountId,
    playerId,
    videoId,
  };
};
